import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchFinish } from '@/api/PMS/customerService/complaintManage';
export default {
  props: ['keyValue', 'flowNum', 'showDialog'],
  data: function data() {
    return {
      userName: this.$store.state.user.name,
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        this.childData = {};
      }
    },
    handleFinish: function handleFinish() {
      var _this2 = this;

      if (this.keyValue > 0) {
        this.childData.complaintId = this.keyValue;
        fetchFinish(this.childData).then(function () {
          _this2.$emit('handCancle');

          _this2.Alert({
            alertType: 'update'
          });
        });
      }
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', 'repairConfirm');
    }
  }
};